// Anomaly severity / type color and label constants shared by the
// Anomalies page, Anomaly Center dashboard and per-anomaly components.

export const SEVERITY_COLORS = {
  critical: '#ef4444',
  high: '#f97316',
  warning: '#f59e0b',
  unknown: '#9ca3af',
};

export const SEVERITY_ORDER = ['critical', 'high', 'warning', 'unknown'];

export const TYPE_COLORS = {
  threshold_breach: '#ef4444',
  zscore_deviation: '#f97316',
  bollinger_band_breach: '#f59e0b',
  sudden_spike: '#8b5cf6',
  sudden_drop: '#3b82f6',
  increasing_trend: '#10b981',
  decreasing_trend: '#06b6d4',
  resource_saturation: '#ec4899',
  vcpu_load_breach: '#dc2626',
  sustained_high_load: '#ea580c',
  vcpu_load_spike: '#d946ef',
  shadow: '#94a3b8',
};

export const TYPE_LABELS = {
  threshold_breach: 'Threshold Breach',
  zscore_deviation: 'Z-Score Deviation',
  bollinger_band_breach: 'Bollinger Band Breach',
  sudden_spike: 'Sudden Spike',
  sudden_drop: 'Sudden Drop',
  increasing_trend: 'Increasing Trend',
  decreasing_trend: 'Decreasing Trend',
  resource_saturation: 'Resource Saturation',
  vcpu_load_breach: 'vCPU Load Breach',
  sustained_high_load: 'Sustained High Load',
  vcpu_load_spike: 'vCPU Load Spike',
  shadow: 'Shadow (Warm-Up)',
};

export const TYPE_DESCRIPTIONS = {
  threshold_breach: 'Metric crossed a fixed warning/critical threshold — the simplest "value too high/low" rule.',
  zscore_deviation: 'Value deviated 3σ or more from its statistical baseline — unusual even if absolute values look normal.',
  bollinger_band_breach: 'Value broke through Bollinger bands (mean ± 2σ) — a sustained shift beyond normal volatility, not a one-off blip.',
  sudden_spike: 'Value jumped sharply (large % change in a short window) compared to its recent rate of change.',
  sudden_drop: 'Value fell sharply (near-total drop) within a short window — often a crashed service or stopped collector.',
  increasing_trend: 'Metric is steadily rising over time — may hit thresholds later if the trend continues.',
  decreasing_trend: 'Metric is steadily falling over time — e.g. shrinking free disk or memory.',
  resource_saturation: 'Resource usage is approaching capacity — the resource risks running out.',
  vcpu_load_breach: 'vCPU-normalized load crossed warn/crit ratios — CPU contention is likely on this host.',
  sustained_high_load: 'Elevated load persisted for a sustained period — consistent pressure, not a momentary spike.',
  vcpu_load_spike: 'vCPU load spiked sharply above its recent average.',
  shadow: 'Detected during baseline warm-up (shadow mode) — informational only, baselines are still being learned.',
};

export const RANGE_OPTIONS = [
  { hours: 24, label: '24 hours' },
  { hours: 168, label: '7 days' },
  { hours: 720, label: '30 days' },
];

export function typeColor(type) {
  return TYPE_COLORS[type] || '#9ca3af';
}

export function typeLabel(type) {
  return TYPE_LABELS[type] || type;
}

export function severityColor(sev) {
  return SEVERITY_COLORS[sev] || '#9ca3af';
}

export function formatVal(v) {
  if (v == null) return '-';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  if (Math.abs(n) >= 1000) return n.toFixed(0);
  if (Math.abs(n) >= 100) return n.toFixed(1);
  return n.toFixed(2);
}
